<template>
  <div :class="['app-container', { 'full-height': !data.length }]">
    <div class="search-container">
      <div class="radio-container">
        <el-radio-group v-model="selectedConstellation" style="height: 60px" fill="var(--adil-blue)">
          <el-radio-button label="狮子座" value="狮子座" />
          <el-radio-button label="双子座" value="双子座" />
        </el-radio-group>

      </div>
      <div class="search-input-container">
        <el-tooltip content="输入商品内容后直接回车即可查询" placement="bottom" effect="light" :offset="10">
          <el-input v-model="query" placeholder="请输入查询内容" prefix-icon="Search" @keydown.enter="handleSearch" />
        </el-tooltip>
      </div>
    </div>

    <div class="update-time-container">
      <div class="update-time" v-if="updateTimes[selectedConstellation + '线路2']">
        <div class="time-info">最早更新: {{ updateTimes[selectedConstellation + '线路2'].earliest }}</div>
        <div class="time-info">最新更新: {{ updateTimes[selectedConstellation + '线路2'].latest }}</div>
      </div>
    </div>

    <!-- 只有在点击搜索后才显示表格 -->
    <div v-if="data.length > 0" class="table-container">
      <div class="info">
        <span>双击即可直接复制地址</span>
      </div>
      <div v-for="group in data" :key="group.name" class="group-container">
        <el-divider>{{ group.name }}</el-divider>
        <el-table :data="group.items" style="margin-top: 20px" @row-dblclick="handleRowDblClick" border>
          <el-table-column prop="name" label="名称" />
          <el-table-column sortable prop="price" label="价格" />
          <el-table-column prop="supermarket_name" label="超市名称" />
          <el-table-column prop="address" label="地址" />
          <el-table-column prop="room_name" label="房间名称" />
        </el-table>
      </div>
    </div>

    <!-- 添加空状态 -->
    <el-empty v-else class="custom-empty" description="请在上方搜索框中输入查询内容后直接回车" />
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { fetchData, fetchUpdateTimes } from "../services/api";
import { ElNotification, ElLoading } from 'element-plus'

export default {
  name: "PricePage",
  setup() {
    const query = ref("");
    const selectedConstellation = ref("狮子座");
    const data = ref([]);
    const loading = ref(false);
    const previousQuery = ref("");
    const previousConstellation = ref(selectedConstellation.value);
    const forbiddenCharacters = /[!*%&<>^]/;
    const updateTimes = ref({});

    const handleSearch = async () => {
      if (forbiddenCharacters.test(query.value)) {
        ElNotification({
          title: '输入内容包含特殊字符',
          type: 'error',
          duration: 1500,
        });
        return;
      }
      if (query.value === "") {
        return;
      }
      if (query.value === previousQuery.value && selectedConstellation.value === previousConstellation.value) {
        ElNotification({
          title: '输入内容相同请勿重复搜索',
          type: 'warning',
          duration: 1500,
        });
        return;
      }

      const loadingInstance = ElLoading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      try {
        const result = await fetchData(query.value, selectedConstellation.value);
        data.value = result;
        previousQuery.value = query.value;
        previousConstellation.value = selectedConstellation.value;
      } catch (error) {
        console.error(error);
      } finally {
        loadingInstance.close();
      }
    };

    watch(selectedConstellation, (newVal) => {
      if (query.value !== "") {
        handleSearch();
      }
    });

    const handleRowDblClick = (row) => {
      const textarea = document.createElement("textarea");
      textarea.value = row.address;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      ElNotification({
        title: '地址复制成功',
        type: 'success',
        duration: 1500,
      });
    };

    // 获取更新时间
    const getUpdateTimes = async () => {
      try {
        const times = await fetchUpdateTimes();
        updateTimes.value = times;
      } catch (error) {
        console.error('获取更新时间失败:', error);
      }
    };

    onMounted(() => {
      getUpdateTimes();
    });

    return {
      query,
      selectedConstellation,
      data,
      loading,
      handleSearch,
      handleRowDblClick,
      updateTimes,
    };
  },
};
</script>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 1;
  /* 使内容区域占据剩余空间 */
  padding: 20px;
  box-sizing: border-box;
}

.full-height {
  height: 100%;
  /* 确保在没有数据时占满整个内容区域 */
}

/* 搜索框容器 */
.search-container {
  width: 100%;
  margin-top: 20px;
  max-width: 1200px;
  display: flex;
  flex-direction: row;
  /* 默认横向布局 */
}

/* 单选框容器 */
.radio-container {
  display: flex;
  width: 30%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.el-radio-group {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

/* 搜索输入框和按钮容器 */
.search-input-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.info {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.info span {
  font-size: 12px;
  color: var(--adil-green);
  display: inline-block;
}

.search-input {
  flex: 1;
  height: 50px;
  font-size: 16px;
  padding: 10px;
  transition: border 0.3s;
}

.search-input:focus {
  /* border-color: #007AFF; 蓝色聚焦边框 */
  outline: none;
}

/* 表格容器 */
.table-container {
  max-width: 1200px;
  width: 100%;
  padding: 20px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 12px -3px rgba(0, 122, 255, 0.2);
  z-index: 1;
  overflow-y: auto;
  /* 允许垂直滚动 */
  flex: 1;
  /* 使表格占据剩余空间 */
}

/* 表格样式 */
.el-table {
  border-radius: 20px;
}

.el-table-column {
  text-align: center;
}

/* 添加表格头部颜色 */
.el-table th {
  background-color: rgba(57, 97, 206, 0.2);
  /* 浅灰色背景 */
}

/* 添加一个平滑的渐变动画效果 */
.search-container,
.table-container {
  animation: fadeIn 0.5s ease-in-out;
}

/* 渐变效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 自定义消息样式 */
.el-message.slide-in {
  animation: slideIn 0.5s ease-in-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

/* 自定义 el-empty 高度 */
.custom-empty {
  height: 600px;
}

/* 移动端样式调整 */
@media (max-width: 768px) {
  .search-container {
    flex-direction: column;
  }

  .radio-container,
  .search-input-container {
    width: 100%;
    margin-bottom: 10px;
  }

  .update-time-container {
    justify-content: flex-end;
    margin: 5px 0;
  }

  .update-time {
    flex-direction: row;
    gap: 10px;
  }
}

.update-time-container {
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}

.update-time {
  font-size: 12px;
  color: var(--adil-secondtext);
  display: flex;
  gap: 10px;
}

.time-info {
  margin: 2px 0;
}

/* 添加 Popover 样式 */
:deep(.el-popover.el-popper) {
  min-width: auto;
  text-align: center;
}

/* 自定义 tooltip 样式 */
:deep(.el-tooltip__popper) {
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 4px;
}
</style>